import dayjs from 'dayjs';

export const isLessThan36Months = (startDate: string) => {
  const now = dayjs();
  const start = dayjs(startDate);
  return now.diff(start, 'month') < 36;
};
